import { EventEmitter, Injectable } from '@angular/core';

declare var bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class OffcanvasService {
  aoFecharOffcanvas = new EventEmitter();
  offcanvas;
  
  constructor() { }

  show (id:string) {
    if(this.offcanvas) {
      this.hide();
    }
    let el = document.getElementById(id);
    this.offcanvas = new bootstrap.Offcanvas(el);
    this.offcanvas.show();
  }
  
  hide() {
    this.aoFecharOffcanvas.emit('offcanvas fechado');
    this.offcanvas.hide();
  }
}
